// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oo-1";
export var messageSideRight = "_oo-2";
export var orderLookupBubbleContainer = "_oo-0";
export var submitButton = "_oo-3";